export const FETCH_USER_DATA = "FETCH_USER_DATA";
export const UPDATE_FOLLOW_DATA = "UPDATE_FOLLOW_DATA";
export const BOOKMARK_POST = "BOOKMARK_POST";
export const LOGOUT = "LOGOUT";
